import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title = 'Nexa Global', 
  description = 'Tienda online de productos de calidad',
  noindex = false,
  nofollow = false,
  canonical = null
}) => {
  const location = useLocation();

  useEffect(() => {
    // Actualizar título
    document.title = title;

    // Actualizar meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      metaDescription.content = description;
      document.head.appendChild(metaDescription);
    }

    // Configurar robots meta tag
    let metaRobots = document.querySelector('meta[name="robots"]');
    const robotsContent = [];
    
    if (noindex) robotsContent.push('noindex');
    if (nofollow) robotsContent.push('nofollow');
    
    if (robotsContent.length > 0) {
      if (metaRobots) {
        metaRobots.setAttribute('content', robotsContent.join(', '));
      } else {
        metaRobots = document.createElement('meta');
        metaRobots.name = 'robots';
        metaRobots.content = robotsContent.join(', ');
        document.head.appendChild(metaRobots);
      }
    } else if (metaRobots) {
      metaRobots.remove();
    }

    // Configurar canonical URL
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    const canonicalUrl = canonical || `${window.location.origin}${location.pathname}`;
    
    if (linkCanonical) {
      linkCanonical.setAttribute('href', canonicalUrl);
    } else {
      linkCanonical = document.createElement('link');
      linkCanonical.rel = 'canonical';
      linkCanonical.href = canonicalUrl;
      document.head.appendChild(linkCanonical);
    }

    // Open Graph tags básicos
    updateOrCreateMetaTag('og:title', title);
    updateOrCreateMetaTag('og:description', description);
    updateOrCreateMetaTag('og:url', canonicalUrl);

  }, [title, description, noindex, nofollow, canonical, location.pathname]);

  return null;
};

// Función helper para crear/actualizar meta tags
const updateOrCreateMetaTag = (property, content) => {
  let metaTag = document.querySelector(`meta[property="${property}"]`);
  if (metaTag) {
    metaTag.setAttribute('content', content);
  } else {
    metaTag = document.createElement('meta');
    metaTag.setAttribute('property', property);
    metaTag.content = content;
    document.head.appendChild(metaTag);
  }
};

export default SEO;
